import { useCallback, useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import JourneyV2DetailsModal from 'components/Flights/V2/FareFamily/JourneyV2DetailsModal'
import DrawerFlightCard from 'tripPlanner/components/Chat/Flights/DrawerFlightCard'

interface Props {
  journey: App.JourneyV2
  onSelect?: (data: { journey: App.JourneyV2 }) => void
  isAlreadyAdded: boolean
  isCartMode: boolean
  isSelectDisabled: boolean
  showSelectButton: boolean
  selectLabel?: string
  onViewDetails?: (journey: App.JourneyV2) => void
}

function FlightSearchResultCard({
  journey,
  onSelect,
  isAlreadyAdded,
  isCartMode,
  isSelectDisabled,
  showSelectButton,
  selectLabel,
  onViewDetails,
}: Props) {
  const showModal = useContext(ModalContext)
  const handleViewDetails = useCallback(() => {
    if (onViewDetails) {
      onViewDetails(journey)
      return
    }
    showModal(<JourneyV2DetailsModal journey={journey} />)
  }, [journey, onViewDetails, showModal])

  return (
    <DrawerFlightCard
      journey={journey}
      onSelect={onSelect}
      onViewDetails={handleViewDetails}
      isAlreadyAdded={!isCartMode && isAlreadyAdded}
      isSelectDisabled={isSelectDisabled}
      selectLabel={selectLabel}
      showSelectButton={showSelectButton}
    />
  )
}

export default FlightSearchResultCard
